import React from 'react';
import PropTypes from 'prop-types';
import errorBoundary from '@ifeng/errorBoundary';
import styles from './index.css';

class CopyRight extends React.PureComponent {
    static propTypes = {
        content: PropTypes.object,
    };

    getNavItem = (item, index) => {
        if (index === 0) {
            return (
                <a className={styles.nolpad} href={item.url} target="_blank" key={index}>
                    {item.title}
                </a>
            );
        } else if (index === 7) {
            return (
                <a className={styles.noborder} href={item.url} target="_blank" key={index}>
                    {item.title}
                </a>
            );
        } else {
            return (
                <a href={item.url} target="_blank" key={index}>
                    {item.title}
                </a>
            );
        }
    };

    render() {
        const { content } = this.props;

        return (
            <div className={styles.copyRightContainer}>
                <div className={`${styles.footlink} ${styles.clearfix}`}>
                    <div className={styles.fk_l}>{content.nav.map((item, index) => this.getNavItem(item, index))}</div>
                </div>
                <div className={styles.copyright}>
                    <span>凤凰新媒体</span>
                    <span>版权所有</span>
                    <span>Copyright © 2016 Phoenix New Media Limited All Rights Reserved.</span>
                </div>
            </div>
        );
    }
}

export default errorBoundary(CopyRight);
